import React from 'react';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import {
  getPdpUrl,
  getPlpProductBrand,
} from '@tcp/core/src/components/features/browse/PlpTile/views/plpTileHelpers/plpTileCommonHelpers.js';
import { extractAttributeValue } from '@tcp/core/src/services/abstractors/productListing/productParser';
import { calculateFinalPrice } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/utils/productsCommonUtils.js';
import styles, { StyledProduct } from '../styles/StoreSpecialTile.style';
import ReviewAndratings from '../../../../../PlpTile/views/ReviewAndratings';
import {
  getAPIConfig,
  getDynamicBadgeQty,
  getIconPath,
  getLocator,
  getProductUrlForDAM,
  isCanada,
} from '../../../../../../../../utils';
import Price from '../../../../../PlpTile/views/Price';
import { AtbIcon } from '../../../../../PlpTile/views/styles/SubmitButton.style';
import { IMG_DATA_PLP } from '../../../../../ProductListing/molecules/ProductList/config';
import PromotionView from '../../../../../PlpTile/views/Promotion.view';

const getTcpStyleQty = (TCPStyleQTYUS, TCPStyleQTYCA) =>
  !isCanada() ? TCPStyleQTYUS : TCPStyleQTYCA;

const getTcpStyleType = (TCPStyleTypeUS, TCPStyleTypeCA) =>
  !isCanada() ? TCPStyleTypeUS : TCPStyleTypeCA;

const handleLinkClick = (setFavoriteStore, store) => {
  setFavoriteStore(store);
};

const renderImage = (
  pdpToPath,
  pdpAsPath,
  index,
  uniqueId,
  productName,
  primaryBrand,
  dynamicBadgeOverlayQty,
  tcpStyleType,
  setFavoriteStore,
  currentStore
) => {
  return (
    <StyledProduct>
      <Anchor
        className="image-link"
        to={pdpToPath}
        asPath={pdpAsPath}
        dataLocator={`${getLocator('moduleTabbed_image_link')}${index}`}
        onClick={() => handleLinkClick(setFavoriteStore, currentStore)}
      >
        <DamImage
          imgData={{
            url: getProductUrlForDAM(uniqueId),
            alt: productName,
          }}
          className="moduleTabbed_carousel_img"
          imgConfigs={IMG_DATA_PLP.imgConfig}
          isProductImage
          lazyLoad={false}
          isHomePage={false}
          itemBrand={primaryBrand}
          primaryBrand={primaryBrand}
          isDamImageV2Enabled={true}
          dynamicBadgeOverlayQty={dynamicBadgeOverlayQty}
          tcpStyleType={tcpStyleType}
          badgeConfig={IMG_DATA_PLP.badgeConfig}
        />
      </Anchor>
    </StyledProduct>
  );
};

const handleClick = (e, uniqueId, onQuickViewOpenClick, setFavoriteStore, currentStore) => {
  e.preventDefault();
  handleLinkClick(setFavoriteStore, currentStore);
  onQuickViewOpenClick({
    colorProductId: uniqueId,
    fromPage: 'StoreDetail',
  });
};

const StoreSpecialTile = (props) => {
  const {
    className,
    product,
    index,
    isDynamicBadgeEnabled,
    onQuickViewOpenClick,
    promotionsData,
    serverTime,
    isBuyMorePromoEnabled,
    isTileRedesignAB,
    isUpdatedPromotionsDisplayEnabled,
    storeSpecialDiscount,
    setFavoriteStore,
    currentStore,
  } = props;
  const apiConfig = getAPIConfig();
  const { brandId: primaryBrand, siteId } = apiConfig;
  const tcpStyleType = getTcpStyleType(product?.TCPStyleTypeUS, product?.TCPStyleTypeCA);
  const tcpStyleQty = getTcpStyleQty(product?.TCPStyleQTYUS, product?.TCPStyleQTYCA);
  const {
    seo_token: seoToken,
    prodpartno: productPartNo,
    tcp_promo_price: TCPPromotionPrice,
    tcp_promotion_id: TCPPromotionID,
  } = product;
  const TCPPrimaryCategory = !isCanada()
    ? extractAttributeValue(product, 'TCPPrimaryCategoryUSStore')
    : extractAttributeValue(product, 'TCPPrimaryCategoryCanadaStore');
  const dynamicBadgeOverlayQty = getDynamicBadgeQty(
    tcpStyleType,
    tcpStyleQty,
    isDynamicBadgeEnabled
  );
  const pdpUrl = getPdpUrl({
    seoToken,
    siteId,
    productPartNo,
    TCPPrimaryCategory,
    fromStoreDetailPage: true,
  });

  const pdpToPath = pdpUrl?.pdpUrl?.href;
  const brand = getPlpProductBrand(product, primaryBrand);
  const tmpPromotionalPrice =
    TCPPromotionID && promotionsData[TCPPromotionID] ? TCPPromotionPrice : '';

  // Calculate the discounted price
  const discountedPriceWithoutPromo = calculateFinalPrice(
    product?.min_offer_price,
    storeSpecialDiscount
  );
  const discountedPriceWithPromo = calculateFinalPrice(
    discountedPriceWithoutPromo,
    storeSpecialDiscount,
    tmpPromotionalPrice
  );
  return (
    <div className={className}>
      <div className="product-tile-container">
        <div className="product-tile">
          {renderImage(
            pdpToPath,
            pdpUrl?.pdpUrl?.asPathWithoutSlug,
            index,
            product?.uniqueId,
            product?.product_name,
            primaryBrand,
            dynamicBadgeOverlayQty,
            tcpStyleType,
            setFavoriteStore,
            currentStore
          )}
          <div className="price-atb-container">
            <Price
              minOfferPrice={discountedPriceWithoutPromo}
              isTileRedesignAB={isTileRedesignAB}
              isHideOriginalPrice={true}
            />

            <AtbIcon
              onClick={(e) =>
                handleClick(
                  e,
                  product?.uniqueId,
                  onQuickViewOpenClick,
                  setFavoriteStore,
                  currentStore
                )
              }
              className="floating-atb-btn"
            >
              <img
                className="atb-icon-image"
                src={getIconPath('add-to-bag-icon-blue')}
                alt="Add to bag"
              />
            </AtbIcon>
          </div>
          {TCPPromotionID && TCPPromotionPrice && (
            <PromotionView
              promotionsData={promotionsData}
              showIcon={false}
              serverTime={serverTime}
              className={'isPLP fromStoreSpecialCaraosal'}
              pageName={'isPLP'}
              brand={brand}
              isBuyMorePromoEnabled={isBuyMorePromoEnabled}
              isTileRedesignAB={isTileRedesignAB}
              TCPPromotionPrice={TCPPromotionPrice}
              TCPPromotionPriceStoreSpecial={discountedPriceWithPromo}
              TCPPromotionID={TCPPromotionID}
              isUpdatedPromotionsDisplayEnabled={isUpdatedPromotionsDisplayEnabled}
              fromStoreSpecialsCarousel
              isPickupSelectedAtProductDetail={true}
              storeSpecials={true}
              fromStoreSpecialCaraosal
            />
          )}

          <ReviewAndratings
            TCPBazaarVoiceRating={product?.TCPBazaarVoiceRating}
            TCPBazaarVoiceReviewCount={product?.TCPBazaarVoiceReviewCount}
            isTileRedesignAB={isTileRedesignAB}
          />
        </div>
      </div>
    </div>
  );
};

export default withStyles(StoreSpecialTile, styles);

export { StoreSpecialTile as StoreSpecialTileVanilla };
